__webpack_require__.p = "/back-office/";